enum CommissionStatus {
    PAID_OFF = 'Lunas',
    IN_FULL_DUE = 'Lunas Jatuh Tempo',
  }
  
  export default CommissionStatus;
  